export interface Timezone {
  value: string;
  label: string;
}

export const TIMEZONES: readonly Timezone[] = [
  { value: "Europe/Kaliningrad", label: "Калининград (МСК-1)" },
  { value: "Europe/Moscow",      label: "Москва (МСК)" },
  { value: "Europe/Samara",      label: "Самара (МСК+1)" },
  { value: "Asia/Yekaterinburg", label: "Екатеринбург (МСК+2)" },
  { value: "Asia/Omsk",          label: "Омск (МСК+3)" },
  { value: "Asia/Krasnoyarsk",   label: "Красноярск (МСК+4)" },
  { value: "Asia/Irkutsk",       label: "Иркутск (МСК+5)" },
  { value: "Asia/Yakutsk",       label: "Якутск (МСК+6)" },
  { value: "Asia/Vladivostok",   label: "Владивосток (МСК+7)" },
  { value: "Asia/Magadan",       label: "Магадан (МСК+8)" },
  { value: "Asia/Kamchatka",     label: "Камчатка (МСК+9)" },
] as const;

export const DEFAULT_TIMEZONE = "Europe/Moscow";
